import React, { useState } from 'react';
import Progress from 'screens/shared/progress-bar';
import Icon from 'screens/shared/icon';
import Card from 'screens/shared/card-basic';
import { useProvisoningStatus } from 'screens/shared/hooks/provisioning-status';
import {
  resourceIconMap, _t, deleteProvisioningItem, getProvisioningItems,
} from 'utils';
import { Collapse } from '@mui/material';
import { actions } from 'redux/local';

// const actionsColorMapper = {
//   UPDATE: '#f28601',
//   CREATE: '#0f9d58',
//   DELETE: '#d23f31',
// };

const statusColorMapper = {
  DONE: 'var(--color-success)',
  FAILED: 'var(--color-danger)',
  QUEUED: 'var(--color-warning)',
};

const typeNameMapper = {
  datacenter: 'DC',
  server: 'SERVER',
  user: 'USER',
  group: 'GROUP',
  resource: 'RES',
  loadbalancer: 'LoadBal',
  backupunit: 'Backup',
  'firewall-rule': 'Firewall',
  'forwarding-rule': 'F-Rule',
  networkloadbalancer: 'NLB',
  'flow-log': 'Flowlog',
  natgateway: 'VNF',
  'natgateway-rule': 'NAT-RULE',
  applicationloadbalancer: 'ALB',
  'target-group': 'T-Group',
  'alb-forwarding-rule': 'ALB-RULE',
};

const getDetails = (items = []) => {
  const total = items.length;
  const done = items.filter(({ status }) => status === 'DONE' || status === 'FAILED').length;
  const percent = (done * 100) / total;
  return { total, done, percent };
};

const isFailed = (items = []) => !!items.filter(({ status }) => status === 'FAILED').length;

const SmallStrap = ({
  onSize,
  total,
  done,
  percent,
  items,
}) => (
  <div
    className={`provisoning-bar-md ${percent === 100 ? isFailed(items) ? 'failed' : 'completed' : ''}`}
    onClick={() => onSize('lg')}
  >
    {percent !== 100 && (
      <Progress value={percent} title={`Provisioning Status: ${done}/${total}`} height={14} color={isFailed(items) ? 'red' : 'green'} />
    )}
    {percent === 100 && <span className={isFailed(items) ? 'failed' : 'completed'}>{_t('All tasks have been completed')}</span>}
    <Icon name="chevron-up" />
  </div>
);

const mapMessage = (msg) => {
  if (msg.includes('VDC-5-604')) {
    return 'S3 bucket name doesn\'t matched with the existing buckets.';
  }

  return msg;
};

const DetailStrap = ({
  onSize,
  items = [],
  total,
  done,
  percent,
  onRemoveAll,
}) => (
  <div className="provisoning-bar-lg">
    <div className="provisoning-bar-lg-top">
      <Progress
        value={percent}
        title={`${_t('Provisioning Status')}: ${done}/${total}`}
        height={20}
        color={isFailed(items) ? 'red' : 'green'}
        onClick={() => onSize('md')}
      />
      <Icon name="chevron-down" style={{ fontSize: 14 }} onClick={() => onSize('md')} />
      <Icon name="ban pointer" style={{ fontSize: 14 }} onClick={() => onRemoveAll()} />
    </div>
    {/* <p style={{ margin: '2px 0 -10px 0', fontSize: 12 }}>All the done and failed tasks will be cleared after the collapse</p> */}
    <div className="cards">
      {items.map((item, index) => {
        const {
          id,
          action,
          message: rawMessage = '',
          name,
          status,
          type,
        } = item;

        const message = mapMessage(rawMessage);
        const buttons = [];

        if (status === 'DONE' || status === 'FAILED') {
          buttons.push({
            name: 'ban',
            onClick: () => onRemoveAll(id),
            style: {
              fontSize: 22,
              boxShadow: 'none',
            },
          });
        } else {
          buttons.push({
            name: 'spinner',
            onClick: (e) => e,
            style: {
              fontSize: 24,
              boxShadow: 'none',
            },
            className: 'round-360 primary-txt',
          });
        }

        return (
          <Card
            key={index}
            title={`${name} (${action})`}
            iconText={typeNameMapper[type] || type}
            details={message}
            icon={resourceIconMap(type)}
            // others={<h5 style={{ background: actionsColorMapper[action] }} className="left-title">{action}</h5>}
            others={<h5 style={{ background: statusColorMapper[status] }} className="left-title">{status}</h5>}
            buttons={buttons}
          />
        );
      })}
    </div>
  </div>
);

export default () => {
  const [size, setSize] = useState('md');
  const [items] = useProvisoningStatus();
  const { total = 0, done, percent } = getDetails(items);

  const onSize = (s) => {
    setSize(s);
  };

  const onRemoveAll = (idToDelete) => {
    if (idToDelete) {
      deleteProvisioningItem(idToDelete);
    } else {
      const itemsToDelete = items.filter(({ status }) => (status === 'DONE' || status === 'FAILED')) || [];

      if (itemsToDelete.length) itemsToDelete.forEach(({ id }) => deleteProvisioningItem(id));
      else items.forEach(({ id }) => deleteProvisioningItem(id));
    }

    const provisioningItems = getProvisioningItems();
    actions.provisioning.setProvisioningItems({ provisioningItems });
    if (!provisioningItems.length) {
      setSize('md');
    }
  };

  return !!total
    && (
      <div className="provisoning-bar">
        <Collapse in={size === 'md'} collapsedSize="0px">
          <SmallStrap onSize={onSize} items={items} {...{ total, done, percent }} />
        </Collapse>

        <Collapse in={size === 'lg'} collapsedSize="0px">
          <DetailStrap onSize={onSize} onRemoveAll={onRemoveAll} items={items} {...{ total, done, percent }} />
        </Collapse>
      </div>
    );
};
